export function getPestPacDisplayName(
  firstName?: string | null,
  lastName?: string | null,
  company?: string | null,
): string {
  const name = [firstName, lastName].filter(Boolean).join(' ').trim()
  const companyName = (company ?? '').trim()

  return [name, companyName].filter(Boolean).join(' / ')
}
